import { Grid } from '@mui/material';
import React from 'react';
import { GridLeft, GridRight, GridSection } from '../../../Episode.Styled';
import {
  CalOMSAdmitSubHeading,
  CheckboxGridItems,
  InputFieldGridItems,
  getCheckboxItems,
  getNotSureYesNoCheckBox,
  getYesNoCheckBox,
} from '../AuthTabCommonUtils';
import {
  employementStatus,
  drugUsedDays,
  getYesNo,
  arrestedDays,
  notSureYesNo,
  getLivingArrangements,
} from '../authTabConstants';
import {
  emp1,
  emp2,
  emp3,
  emp4,
  leg3,
  leg4,
  leg5,
  med2,
  med3,
  med4,
  med6,
  med11,
  med12,
  mhd1,
  mhd2,
  mhd3,
  mhd4,
  soc1,
  soc2,
  soc3,
  soc4,
  soc5,
  soc6,
  soc7,
  soc8,
} from './CalOMSQuestionnaireConstants';
import { useSelector } from 'react-redux';

const PageTwoCalOMSDischarge = () => {
  const getCalOMSAdmitPdfForm = useSelector(
    (state) => state?.CalOMSDischargeForm?.data
  );

  const {
    cdEmpSts,
    cdPaidWork = '',
    cdEnrSch,
    cdEnrJob,
    cdArrested,
    cdJail,
    cdPrison,
    cdHivAidsTest,
    cdMedER,
    cdPregTmt,
    cdMedProb,
  } = getCalOMSAdmitPdfForm || {};

  return (
    <Grid container>
      <GridSection mx={2} container spacing={1}>
        <GridLeft item container xs={6}>
          <CalOMSAdmitSubHeading title="Employement / Education" />

          <CheckboxGridItems
            heading="EMP-1"
            data={getCheckboxItems(employementStatus, cdEmpSts)}
            text={emp1}
          />

          <InputFieldGridItems heading="EMP-2" value={cdPaidWork} text={emp2} />

          <CheckboxGridItems
            heading="EMP-3"
            data={getYesNoCheckBox(getYesNo, cdEnrSch)}
            text={emp3}
          />

          <CheckboxGridItems
            heading="EMP-4"
            data={getYesNoCheckBox(getYesNo, cdEnrJob)}
            text={emp4}
          />

          <CalOMSAdmitSubHeading title="Legal / Criminal Justice" />

          <CheckboxGridItems
            heading="LEG-3"
            data={getCheckboxItems(arrestedDays, cdArrested)}
            text={leg3}
          />

          <CheckboxGridItems
            heading="LEG-4"
            data={getCheckboxItems(drugUsedDays, cdJail)}
            text={leg4}
          />

          <CheckboxGridItems
            heading="LEG-5"
            data={getCheckboxItems(drugUsedDays, cdPrison)}
            text={leg5}
          />

          <CalOMSAdmitSubHeading title="Medical / Physical Health" />

          <CheckboxGridItems
            heading="MED-2"
            data={getCheckboxItems(arrestedDays, cdMedER)}
            text={med2}
          />

          <CheckboxGridItems
            heading="MED-3"
            data={getCheckboxItems(drugUsedDays, cdMedProb)}
            text={med3}
          />

          <CheckboxGridItems heading="MED-4" data={drugUsedDays} text={med4} />

          <CheckboxGridItems
            heading="MED-6"
            data={getNotSureYesNoCheckBox(notSureYesNo, cdPregTmt)}
            text={med6}
          />

          <CheckboxGridItems
            heading="MED-11"
            data={getYesNoCheckBox(getYesNo, cdHivAidsTest)}
            text={med11}
          />

          <CheckboxGridItems heading="MED-12" data={getYesNo} text={med12} />
        </GridLeft>

        <GridRight item container xs={6}>
          <CalOMSAdmitSubHeading title="Mental Health" />

          <CheckboxGridItems heading="MHD-1" data={notSureYesNo} text={mhd1} />

          <CheckboxGridItems heading="MHD-2" data={arrestedDays} text={mhd2} />

          <CheckboxGridItems heading="MHD-3" data={drugUsedDays} text={mhd3} />

          <CheckboxGridItems heading="MHD-4" data={getYesNo} text={mhd4} />

          <CalOMSAdmitSubHeading title="Social / Family" />

          <CheckboxGridItems heading="SOC-1" data={drugUsedDays} text={soc1} />

          <CheckboxGridItems
            heading="SOC-2"
            data={getLivingArrangements}
            text={soc2}
          />

          <CheckboxGridItems heading="SOC-3" data={drugUsedDays} text={soc3} />

          <CheckboxGridItems heading="SOC-4" data={drugUsedDays} text={soc4} />

          <CheckboxGridItems heading="SOC-5" data={drugUsedDays} text={soc5} />

          <CheckboxGridItems heading="SOC-6" data={drugUsedDays} text={soc6} />

          <CheckboxGridItems heading="SOC-7" data={drugUsedDays} text={soc7} />

          <CheckboxGridItems heading="SOC-8" data={drugUsedDays} text={soc8} />
        </GridRight>
      </GridSection>
    </Grid>
  );
};

export default PageTwoCalOMSDischarge;
